"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
exports.ForumModeratorIcon = function (props) { return (React.createElement("svg", __assign({ width: "13", height: "16", viewBox: "0 0 13 16" }, props),
    React.createElement("path", { d: "M6.29,11.51,2.9,13.79h0a.4.4,0,0,1-.55-.11.39.39,0,0,1-.05-.35L3.52,9.42.16,7h0A.41.41,0,0,1,.08,6.4a.38.38,0,0,1,.31-.16l4.23-.09L6,2.26H6a.4.4,0,0,1,.75,0l1.4,3.89,4.23.09h0a.4.4,0,0,1,.4.41.42.42,0,0,1-.17.31L9.28,9.42l1.23,3.91h0a.4.4,0,0,1-.26.51.45.45,0,0,1-.34-.05l-3.4-2.28h0A.22.22,0,0,0,6.29,11.51Z" }))); };
//# sourceMappingURL=forum-moderator.js.map